import React from "react";
import { IRouteItem, Loadable } from "@techzyapp/ui-lib";
import { TERMS_AND_CONDITIONS_PAGE_PATH } from "utils/constants/paths";

const TermsAndConditionsPage = Loadable(React.lazy(() => import("./View")));

export const TermsAndConditionsPageRoute: IRouteItem = {
  path: TERMS_AND_CONDITIONS_PAGE_PATH,
  element: React.createElement(TermsAndConditionsPage),
  name: "Terms And Conditions",
};
